import { useState } from 'react'
import { Show, SimpleShowLayout, useRecordContext } from 'react-admin'
import { url2 } from '../utils'
import { Box, Grid, Typography, makeStyles } from '@material-ui/core'
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from '@material-ui/core/styles'
import ApartmentIcon from '@mui/icons-material/Apartment'
import { normalizeUnits } from 'moment'
const moment = require('moment')

// == Below are deprecated comments about footer handling ==
//
// - pour éviter que 1 bloc de résolution morde sur le footer en bas de page: on a déjà un page-break avoid sur chaque bloc de résolution. Du coup il suffit de mettre un placeholder ayant la height du footer, en-dessous de chaque bloc de résolution.
// --> stratégie de type 1: on fait en sorte que chaque unité de no-page-break ait un blanc juste en dessous de la height du footer, comme ça pas d'overlap

// - pour éviter que la liste des copropriétaires ne morde sur le footer: ici on peut pas utiliser la stratégie de type 1, si on ajoute un blanc de la taille du footer en-dessous de chaque ligne ça va être trop galère.
// Du coup on va faire des blocks prenant chacun tt une page
// --> stratégie de type 2: on fait des batchs auxquels on applique la stratégie de type 1. Chaque bloc doit prendre plus de 1/2 page height,
//pour pas en avoir 2 sur une mm page séparés par un placeholder

// - pour éviter que l'ordre du jour (liste des intitulés de résolutions au début) ne morde sur le footer, on va faire des packets de 10, et sur chaque packet de 10 on met un no page break inside, et un placeholder juste en-dessous de la taille du footer
// --> stratégie de type 2

// - pour éviter que le texte trop long d'une résolution morde sur le footer: trop galère de deviner
// la height d'un texte de résolution, pour le moment on a simplement réduit la fontSize des Typography
//
// == End of the deprecated comments about footer handling ==

// From now on, to deal with the footer we followed this link, section "ULTIMATE METHOD" at the bottom
// https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a

const useStyles = makeStyles((theme) => ({
  apartmentInfoWrapper: {
    display: 'flex',
  },
  apartmentIcon: {
    fontSize: '3em!important',
    color: theme.palette.grey.A100,
    padding: '.2em!important',
  },
  resolutionTitle: {
    borderBottom: `2px solid ${theme.palette.grey.A100}`,
  },
  resolutionResult: {
    borderTop: `1px dotted black`,
    borderBottom: `1px dotted black`,
    textAlign: 'center',
    padding: '4px 0',
    marginTop: '0.35em',
  },
  noLineHeight: {
    lineHeight: '1',
    overflowWrap: 'break-word',
    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },
  },
}))

const BaseUnit = (props) => (
  <div style={{ breakInside: 'avoid' }}>{props.children}</div>
)

const Title = () => {
  const record = useRecordContext()
  const classes = useStyles()

  return (
    <>
      <Typography variant="h5" style={{ marginTop: '-80px' }}>
        <b>
          Procès verbal pour l'Assemblée Générale{' '}
          {record.estordinaire ? 'Ordinaire' : 'Extraordinaire'}
        </b>
      </Typography>
      <Typography variant="subtitle2" color="black">
        {record.ag_libelle}
      </Typography>
      <Typography variant="subtitle2" color="primary" gutterBottom>
        <b>
          AG tenue le {moment(record.datereelle).format('DD/MM/YYYY')} à{' '}
          {moment(record.datereelle).format('HH:mm')}
        </b>
        <br />
        <b>Lieu : {record.lieu}</b>
      </Typography>
      <div className={classes.apartmentInfoWrapper}>
        <ApartmentIcon className={classes.apartmentIcon} />
        <Typography variant="subtitle2">
          <b style={{ fontSize: 'large' }}>Immeuble</b>
          <br />
          {record.libelle}
          <br />
          {record.adresse} {record.codepostal} {record.ville}
        </Typography>
      </div>
      <br />
      <Typography variant="body2">
        Cher membre du syndicat des copropriétaires,
      </Typography>
      <Typography variant="body2" gutterBottom>
        Le {record.date_reelle}, les copropriétaires se sont réunis en Assemblée
        Générale, sur convocation adressée par le syndic, afin de délibérer sur
        l'ordre du jour suivant :
      </Typography>
    </>
  )
}

const ResolutionTitle = (props) => {
  const { record } = props
  return (
    <Typography variant="body2">
      <b>
        {record.numero}) {record.libelle}
      </b>{' '}
      - Majorité {record.majorite_bo}
    </Typography>
  )
}

const Title2 = () => (
  <div>
    <Typography variant="body2">
      Une feuille de présence mentionnant les noms, prénoms et adresse de chacun
      des copropriétaires a été émargée par chacun d'eux lors de l'entrée en
      séance, tant en leur nom personnel, que le cas échéant, à titre de
      mandataire.
    </Typography>
    <Typography variant="body2">
      Après vérification de la feuille de présence, il est constaté que :
    </Typography>
  </div>
)

const Title3 = () => {
  const record = useRecordContext()

  return (
    <div>
      <Typography variant="body2">
        Sont absents et non représentés : {record.absents_count} /{' '}
        {record.absents_count + record.presents_count} copropriétaires
        représentant {record.absents_tantiemes} /{' '}
        {record.absents_tantiemes + record.presents_tantiemes} tantièmes.
      </Typography>
      <Typography variant="body2">
        L'assemblée est déclarée régulièrement constituée et peut donc
        valablement délibérer.
      </Typography>
    </div>
  )
}
const CoownersPresenceStats = () => {
  const record = useRecordContext()

  return (
    <div>
      <Typography variant="body2">
        Sont présents ou représentés : {record.presents_count} /{' '}
        {record.absents_count + record.presents_count} copropriétaires
        représentant {record.presents_tantiemes} /{' '}
        {record.absents_tantiemes + record.presents_tantiemes} tantièmes.
      </Typography>
    </div>
  )
}

const Title4 = () => {
  const record = useRecordContext()

  return (
    <BaseUnit>
      <Typography variant="body2" gutterBottom>
        L'ordre du jour étant épuisé, plus aucune question n'étant posée,
        l'Assemblée{' '}
        {!record.end_datetime || record.end_datetime === null
          ? "n'est pas encore terminée."
          : 'se termine le ' +
            moment(record.end_datetime).format('DD/MM/YYYY') +
            ' à ' +
            moment(record.end_datetime).format('HH:mm')}
      </Typography>
      <Typography variant="body2">
        Conformément à l'article 42.2 de la loi du 10 juillet 1965 modifié par
        l'article 14 de la loi du 31 décembre 1985 :{' '}
        <i>
          « Les actions qui ont pour objet de contester les décisions des
          Assemblées Générales doivent, à peine de déchéance, être introduites
          par les copropriétaires opposants ou défaillants, dans un délai de
          deux mois à compter de la notification desdites décisions qui leur est
          faite à la diligence du syndic, dans un délai de deux mois à compter
          de la tenue de l'assemblée générale. Sauf en cas d'urgence,
          l'exécution par le syndic des travaux décidés par l'assemblée générale
          en application des articles 25 et 26 est suspendue jusqu'à
          l'expiration du délai mentionné à la première phrase du présent alinéa
          ».
        </i>
      </Typography>
      <Typography
        variant="body2"
        align="right"
        gutterBottom
        style={{ marginTop: '10px' }}
      >
        <b>Fait à :</b> {record.lieu}
      </Typography>
      <Typography variant="body2" align="right" gutterBottom>
        <b>Le:</b> {moment(record.end_datetime).format('YYYY-MM-DD')}
      </Typography>
      <Grid container direction="row" alignItems="start" justify="center">
        <Grid item xs={3}>
          <Grid container direction="row" alignItems="center" justify="center">
            <Grid item xs={12}>
              <Typography variant="body2" color="black">
                Le Président :
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '30px' }}>
              <span
                style={{
                  color: 'white',
                  '-webkit-print-color-adjust': 'exact',
                }}
              >
                [[s|0]]
              </span>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Grid container direction="row" alignItems="center" justify="center">
            <Grid item xs={12}>
              <Typography variant="body2" color="black">
                Le Secrétaire :
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '30px' }}>
              <span
                style={{
                  color: 'white',
                  '-webkit-print-color-adjust': 'exact',
                }}
              >
                [[s|1]]
              </span>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Grid container direction="row" alignItems="center" justify="center">
            <Grid item xs={12}>
              <Typography variant="body2" color="black">
                Le(s) Scrutateur(s) :
              </Typography>
            </Grid>
            <Grid item container xs={12} style={{ marginTop: '30px' }}>
              <Grid item xs={12}>
                <span
                  style={{
                    color: 'white',
                    '-webkit-print-color-adjust': 'exact',
                  }}
                >
                  [[s|2]]
                </span>
              </Grid>
              <Grid item xs={12} style={{ marginTop: '30px' }}>
                <span
                  style={{
                    color: 'white',
                    '-webkit-print-color-adjust': 'exact',
                  }}
                >
                  [[s|3]]
                </span>
              </Grid>
              <Grid item xs={12} style={{ marginTop: '30px' }}>
                <span
                  style={{
                    color: 'white',
                    '-webkit-print-color-adjust': 'exact',
                  }}
                >
                  [[s|4]]
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
    </BaseUnit>
  )
}

const Title5 = () => (
  <div style={{ pageBreakBefore: 'always' }}>
    <Typography variant="h5">
      <b>Annexe Votes Opposant</b>
    </Typography>
  </div>
)

const Votes = () => {
  const record = useRecordContext()
  const votesMap = new Map()
  record.resolutions.forEach((r, idx) => {
    let filter = 'Contre'

    if (r.status === 'Rejetée' || r.status === 'Contre') {
      filter = 'Pour'
    }

    if (r.votes.filter((v) => v.vote === filter).length === 0) return null

    r.votes
      .filter((v) => v.vote === filter && v.tantiemes !== '0')
      .forEach((v) => {
        const currentTantiemes = parseInt(v.tantiemes)

        if (
          !votesMap.has(v.libelle) ||
          currentTantiemes > votesMap.get(v.libelle)
        ) {
          votesMap.set(v.libelle, currentTantiemes)
        }
      })
  })
  const votes_string = Array.from(votesMap, ([libelle]) => libelle)

  if (votes_string.length === 0) {
    return <Typography variant="body2">Aucun opposant</Typography>
  }
  return <Typography variant="body2">{votes_string.join(', ')}</Typography>
}

const ResolutionContent = (props) => {
  const record = useRecordContext(props)
  const classes = useStyles()

  return (
    <Typography
      className={classes.noLineHeight}
      variant="body2"
      dangerouslySetInnerHTML={{ __html: record.contenu_bo }}
    />
  )
}

const ResolutionBody = (props) => {
  const { record, resolutions, idx, totalTantiemesPresent } = props
  const classes = useStyles()
  var first_votes = []
  var rec = {}
  //We record all ag_registrations ids that voted in past resolutions
  resolutions.map((r, i) => {
    if (i < idx) {
      r.votes
        .filter((v) => v.id !== null)
        .map((v) => {
          rec[v['agr_id']] = true
        })
    }
  })
  //We check which current resolution voters never voted before
  record.votes
    .filter((v) => v.id !== null)
    .map((v) => {
      if (rec[v['agr_id']] === undefined) {
        first_votes.push(v)
      }
    })
  // get resolution status Pour == adoptée / contre == Rejetée
  function getResolutionStatus(status) {
    if (status === 'Pour') {
      return 'Adoptée'
    } else if (status === 'Contre') {
      return 'Rejetée'
    } else {
      return status
    }
  }

  return (
    <div>
      <Typography
        className={classes.resolutionTitle}
        variant="h6"
        color="black"
      >
        <b>
          {record.numero}. {record.libelle}
        </b>
      </Typography>
      <ResolutionContent {...props} />
      {
        <div>
          {record.majorite_bo === 'sans vote' ? (
            <Typography className={classes.noLineHeight} variant="body2">
              Majorité : {record.majorite_bo}
            </Typography>
          ) : (
            <div>
              <Typography className={classes.noLineHeight} variant="body2">
                Clé de répartition : {record.repartition_libelle}
              </Typography>
              <Typography className={classes.noLineHeight} variant="body2">
                Sur une base de calcul de :{' '}
                {record.majorite_bo === 'simple'
                  ? totalTantiemesPresent
                  : record.copro_tantiemes}{' '}
                tantièmes
              </Typography>
              <Typography className={classes.noLineHeight} variant="body2">
                Ont voté <b>pour</b> : {record.coproprietaires_pour}{' '}
                copropriétaires représentant{' '}
                {record.tantiemes_pour !== null ? record.tantiemes_pour : 0}{' '}
                tantièmes.
              </Typography>
              <Typography
                className={classes.resolutionResult}
                variant="body2"
                gutterBottom
              >
                <b>En vertu de quoi cette résolution est :</b>{' '}
                {getResolutionStatus(record.status)} (majorité :{' '}
                {record.majorite_bo})
              </Typography>
              {first_votes.length > 0 && (
                <Typography className={classes.noLineHeight} variant="body2">
                  Copropriétaire(s) votant pour la 1ère fois :{' '}
                  {first_votes.map((v) => v.libelle).join(', ')}
                </Typography>
              )}
            </div>
          )}
        </div>
      }
    </div>
  )
}

//Before we used an ArrayField + Datagrid, but since it generated a table we had issues
//applying print-friendly css, to avoid text being cut-off
const Resolutions = () => {
  const record = useRecordContext()

  return (
    <div>
      {record.resolutions.map((r, idx) => {
        return (
          <BaseUnit key={idx}>
            <ResolutionBody
              record={r}
              idx={idx}
              resolutions={record.resolutions}
              totalTantiemesPresent={record.total_tantieme_presents}
            />
          </BaseUnit>
        )
      })}
    </div>
  )
}

const Footer = () => (
  <div
    className="footer"
    style={{ position: 'fixed', bottom: '5px', left: '100px' }}
  >
    <Box display="flex" alignItems="center" justifyContent="center">
      <Box mr="0.5em" ml="0.5em">
        <img
          src={url2}
          style={{ maxWidth: '10vw', marginTop: '0px', marginLeft: '25px' }}
        />
      </Box>
      <Box flex={8} mr="0.5em" ml="0.5em">
        <Typography style={{ fontSize: '0.40rem' }}>
          Manda (Ex-Hello Syndic) SAS au capital de 31.015 € - 828 499 897 RCS
          PARIS, ayant son siège social 30 Terrasse Bellini - 92800 Puteaux
        </Typography>
        <Typography style={{ fontSize: '0.40rem' }}>
          N° de TVA intracommunautaire : FR 27 828499897
        </Typography>
        <Typography style={{ fontSize: '0.40rem' }}>
          Carte professionnelle CPI 7501 2017 000 019 252 RCS de Paris, garantie
          financière auprès de GALIAN.
        </Typography>
      </Box>
    </Box>
  </div>
)

const splitArrayChunks = (arr, chunk_length) => {
  var nb_blocks = Math.floor(arr.length / chunk_length)
  var new_arr = []
  for (var k = 0; k < nb_blocks; k++) {
    new_arr.push(arr.slice(k * chunk_length, (k + 1) * chunk_length))
  }
  new_arr.push(arr.slice(nb_blocks * chunk_length, arr.length))
  return new_arr
}

const IntroResolutions = (props) => {
  const record = useRecordContext()
  var block_length = 20
  var chunks = splitArrayChunks(record.resolutions, block_length)
  return (
    <div>
      {chunks.map((c, i1) => {
        return (
          <BaseUnit key={i1}>
            {c.map((e, i2) => {
              return (
                <div key={i2}>
                  <ResolutionTitle record={e} />
                </div>
              )
            })}
          </BaseUnit>
        )
      })}
    </div>
  )
}

const IntroPresents = () => {
  const record = useRecordContext()
  const classes = useStyles()

  if (record.coproprietaires_presents === null) return null
  var block_length = 45
  var chunks = splitArrayChunks(record.coproprietaires_presents, block_length)

  return (
    <div>
      {chunks.map((c, i1) => {
        return (
          <BaseUnit key={i1}>
            {c.map((e, i2) => (
              <Typography
                className={classes.noLineHeight}
                key={i2}
                variant="body2"
                component={'span'}
              >
                {e.libelle} - {e.tantiemes};
              </Typography>
            ))}
          </BaseUnit>
        )
      })}
    </div>
  )
}

const IntroAbsents = (props) => {
  const record = useRecordContext()
  const classes = useStyles()
  if (record.coproprietaires_absents === null) return null
  var block_length = 45
  var chunks = splitArrayChunks(record.coproprietaires_absents, block_length)

  return (
    <div>
      {chunks.map((c, i1) => {
        return (
          <BaseUnit key={i1}>
            {c.map((e, i2) => (
              <Typography
                className={classes.noLineHeight}
                key={i2}
                variant="body2"
                component={'span'}
              >
                {e.libelle} - {e.tantiemes};
              </Typography>
            ))}
          </BaseUnit>
        )
      })}
    </div>
  )
}

const createCustomTheme = (fontSize = 8) => {
  return createTheme({
    overrides: {
      body: {
        root: {
          backgroundColor: 'blue',
        },
      },
    },
    palette: {
      primary: {
        main: '#143A5F',
        contrastText: '#ffffff',
      },
    },
    typography: {
      fontFamily: 'Helvetica',
      fontSize: fontSize,
    },
  })
}

const RowRenderVote = ({ votes, borders }) =>
  votes.length > 0 && (
    <>
      {' '}
      <tr
        style={{
          pageBreakInside: 'avoid',
        }}
      >
        <td style={borders}>
          <Typography variant="body2">
            <b>{votes[0].vote}</b>
          </Typography>
        </td>
        <td style={borders}>
          <Typography variant="body2">
            {votes
              .filter((vote) => vote.tantiemes > 0)
              .map(({ libelle, tantiemes }) => `${libelle} (${tantiemes})`)
              .join(', ')}
          </Typography>
        </td>
        <hr />
      </tr>
    </>
  )

const VotesByResolution = () => {
  const { resolutions } = useRecordContext()
  const borders = {
    border: '1px solid black',
    padding: '1px',
  }

  return (
    <>
      <Typography variant="h6">Détail des votes</Typography>
      <table
        style={{
          textAlign: 'left',
          fontSize: '3px',
        }}
      >
        <tbody
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {resolutions.map(
            ({
              votes,
              libelle,
              tantiemes_pour,
              tantiemes_contre,
              tantiemes_abstention,
              numero,
            }) => {
              if (votes.length === 0) return null

              const aprovers = votes.filter((v) => v.vote === 'Pour')
              const decliners = votes.filter((v) => v.vote === 'Contre')
              const absteiners = votes.filter((v) => v.vote === 'Abstention')

              return (
                <>
                  <tr
                    style={{
                      pageBreakInside: 'avoid',
                      marginBottom: '20px',
                    }}
                  >
                    <table
                      style={{
                        borderSpacing: '0px',
                        borderCollapse: 'collapse',
                      }}
                    >
                      <tbody>
                        <tr>
                          <th colSpan={2}>
                            <Typography color="primary" variant="body2">
                              {numero}. {libelle} (Pour: {tantiemes_pour || 0}{' '}
                              Contre: {tantiemes_contre || 0} Abstention:{' '}
                              {tantiemes_abstention || 0})
                            </Typography>
                          </th>
                        </tr>
                        <RowRenderVote votes={aprovers} />
                        <RowRenderVote votes={decliners} />
                        <RowRenderVote votes={absteiners} />
                      </tbody>
                    </table>
                  </tr>
                </>
              )
            }
          )}
        </tbody>
      </table>
    </>
  )
}

const Pv = (props) => {
  const ag = useRecordContext(props)
  if (!ag) return null

  const customTheme = createCustomTheme(12)
  return (
    <div
      style={{
        marginLeft: '40px',
        marginRight: '40px',
        overflowWrap: 'break-word',
      }}
    >
      <table style={{ width: '100%', tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <td>
              <div style={{ height: '80px' }}>&nbsp;</div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ whiteSpace: 'normal' }}>
              {/* <SimpleShowLayout elevation={0}> */}
              <Title />
              <IntroResolutions />
              <br />
              <Title2 />
              <br />
              <Typography variant="body2">
                Copropriétaires présents ou représentés : (nom - tantièmes)
              </Typography>
              <IntroPresents />
              <br />
              <CoownersPresenceStats />
              <br />
              <Typography variant="body2">
                Copropriétaires absents : (nom - tantièmes)
              </Typography>
              <IntroAbsents />
              <br />
              <Title3 />
              <br />
              <Resolutions />
              <br />
              <Title4 />
              <br />
              <Title5 />
              <Votes />
              <VotesByResolution />
              {/* </SimpleShowLayout> */}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div style={{ height: '60px' }}>&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>
      <Footer />
    </div>
  )
}

export const PvAg = (props) => {
  const [open_resolution_id, setOr] = useState(null)
  const [not_ready, setR] = useState(false)

  return (
    <Show {...props}>
      <Pv {...props} />
    </Show>
  )
}
